import { OnInit } from '@angular/core';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, pluck } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';
// Models
import { PTMIntermediate } from 'src/app/business/models/ptm-intermediate';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';
// Queries
import { PTMIntermediateQuery } from '../../queries/ptm-intermediate.query';
// Services
import { HelpersService } from 'src/app/shared/services/helpers.services';
import { setPageTitle } from 'src/app/shared/utilities/utils';
import { MetatagsService } from 'src/app/shared/services/metatags.service';
import { CanonicalRoutesService } from 'src/app/shared/services/canonical-routes.service';

@Component({
  selector: 'app-ptm-intermediate',
  templateUrl: './ptm-intermediate.component.html',
  styleUrls: ['./ptm-intermediate.component.scss']
})
export class PTMIntermediateComponent implements OnInit, OnDestroy {
  public pageData: PTMIntermediate;

  // Breadcrumbs
  public pages: Breadcrumbs[];

  private appEnvironment: string;

  constructor(
    private ptmQuery: PTMIntermediateQuery,
    private route: ActivatedRoute,
    private helpers: HelpersService,
    private app: AppService,
    private metaTags: MetatagsService,
    private canonical: CanonicalRoutesService
  ) {
    this.appEnvironment = this.app.configuration['GraphCMS']['environment'];

    this.route.params.subscribe(params => {
      this.ptmQuery
        .watch({
          friendlyId:
            params[this.helpers.propertyOf<PTMIntermediate>('friendlyId')]
        })
        .valueChanges.pipe(
          pluck('data', 'pTMs'),
          map(r => r[0])
        )
        .subscribe((response: PTMIntermediate) => {
          if (!response) { this.helpers.redirectTo404(); return; }
          this.pageData = response;

          const titleElement = document.querySelector('title');
          setPageTitle(titleElement, this.pageData.tituloPaginaIntermedia);

          this.metaTags.setMetaTags(response.metaDescripciones);

          this.pages = [
            { page: 'Empresas', route: '/empresas', isActive: false },
            { page: this.pageData.nombrePublico, isActive: true }
          ];
        });
    });
  }

  ngOnInit(): void {
    this.canonical.setCanonicalRoute();
  }

  ngOnDestroy(): void {
    this.metaTags.removeMetaTags(this.pageData.metaDescripciones);
  }
}
